// selectors
import {getCurrentColorId} from '~/selectors/ProductSelectors';
import {getSaveResponse} from '~/selectors/SaveResponseSelectors';

export function select(state) {
  const saveResponse = getSaveResponse(state);
  const productKey = getCurrentColorId(state);
  return {saveResponse, productKey};
}
